// extracted by mini-css-extract-plugin
export var createdDate = "_iz-1";
export var divider = "_iz-2";
export var headerDivider = "_iz-3";
export var messagesCard = "_iz-0";
export var messagesContainer = "_iz-7";
export var messagesContainerWrapper = "_iz-4";
export var pointerCapturingButtonBoxes = "_iz-a";
export var showLeftPanelButton = "_iz-9";
export var showMoreButton = "_iz-c";
export var showMoreButtonContainer = "_iz-b";
export var summaryTitle = "_iz-6";
export var systemMessageCardWrapper = "_iz-d";
export var topButtons = "_iz-8";
export var withPadding = "_iz-5";